/* Component Dependencies */
var travelInsuranceModificationAlertTemplate = require('templates/travelInsuranceModificationAlert.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'travelInsuranceModificationAlert',
  template: {
    'travelInsuranceModificationAlert': travelInsuranceModificationAlertTemplate
  },
  subscribe: {
    'REFRESH_ORG_BOOKING_DETAILS': 'updateModificationAlertTile',
    'EDIT_PREF_CLOSE': 'updateModificationAlertTile'
  },
  bindEvents: function () {
    var _self = this;
    _self.addNewTabTargetAttribute.call(_self);
    _self.addCSSToAnchorTag.call(_self);
    _self.addClickAttributeToAnchor.call(_self);
    _self.addImpressionTrack.call(_self);
  },
  updateModificationAlertTile: function _updateModificationAlertTile() {
    var _self = this;
    context = {
      tripDetailsUpdated: true
    }
    _self.refresh(context);
   },
  addNewTabTargetAttribute: function () {
    $(".tile-alert-policy-change a").attr("target", "_blank");
  },
  addCSSToAnchorTag: function () {
    $(".tile-alert-policy-change a").addClass("js-allianz-policy-link analytics-click l-margin-none l-display-inline custom_click_track");
  },
  addClickAttributeToAnchor: function () {
    $(".tile-alert-policy-change a").attr("data-custom_click_track_value", "Alert|upcomingRes|external|event167,list3=ModifyAlertMessage;type=insurance;msg=travelInsurance0921;tag=US-");
  },
  addImpressionTrack: function () {
    if ($(".tile-alert-policy-change").length > 0) {
      window.impressionTrack("Alert|upcomingRes|external|event168|list3=ModifyAlertMessage,type=insurance,msg=travelInsurance0921,tag=US-");
    }
  }
});
